import React from "react";

import DateFnsUtils from "@date-io/date-fns";
import { Grid, createTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import {
	DatePickerProps as DpProps,
	MuiPickersUtilsProvider,
	DatePicker as Picker,
	TimePicker,
	TimePickerProps
} from "@material-ui/pickers";

const defaultMaterialTheme = createTheme({
	palette: {
		primary: {
			main: "rgba(38, 79, 174, 1)"
		}
	},
	typography: {
		allVariants: {
			color: "hsl(224,18%,12%)"
		}
	}
});

export type DatePickerProps = (Partial<TimePickerProps> | Partial<DpProps>) & { isTimePicker?: boolean };

export const DatePicker = ({ isTimePicker = false, ...props }: DatePickerProps) => (
	<MuiPickersUtilsProvider utils={DateFnsUtils}>
		<Grid container justifyContent="space-around">
			<ThemeProvider theme={defaultMaterialTheme}>
				{isTimePicker ? <TimePicker {...(props as TimePickerProps)} /> : <Picker {...(props as DpProps)} />}
			</ThemeProvider>
		</Grid>
	</MuiPickersUtilsProvider>
);

export default DatePicker;
